import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { bookingAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';

const STATUS_LABELS = {
  pending: { label: 'Pending', cls: 'badge-orange' },
  confirmed: { label: 'Confirmed ✓', cls: 'badge-green' },
  in_progress: { label: 'In Progress', cls: 'badge-gold' },
  completed: { label: 'Completed 🎉', cls: 'badge-green' },
  cancelled: { label: 'Cancelled', cls: 'badge-red' },
};

export default function ClientDashboard() {
  const { user } = useAuth();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('all');

  useEffect(() => {
    bookingAPI.getMyBookings()
      .then(({ data }) => setBookings(data?.bookings || data || []))
      .finally(() => setLoading(false));
  }, []);

  const filtered = activeTab === 'all' ? bookings : bookings.filter(b => b.status === activeTab);

  const hasCompleted = bookings.some(b => b.status === 'completed');
  const completedCount = bookings.filter(b => b.status === 'completed').length;

  const stats = {
    total: bookings.length,
    pending: bookings.filter(b => b.status === 'pending').length,
    confirmed: bookings.filter(b => b.status === 'confirmed').length,
    completed: completedCount,
  };

  return (
    <div className="dashboard-page page">
      <div className="container">
        <div className="dash-header">
          <div>
            <h1>Namaste, {user?.name}! 👋</h1>
            <p>Tumhari saari bookings yahan hain</p>
          </div>
          <Link to="/decorators" className="btn btn-primary">+ Nayi Booking</Link>
        </div>

        {/* Stats */}
        <div className="dash-stats">
          {[
            { icon: '📋', label: 'Total Bookings', value: stats.total },
            { icon: '⏳', label: 'Pending', value: stats.pending },
            { icon: '✅', label: 'Confirmed', value: stats.confirmed },
            { icon: '🎉', label: 'Completed', value: stats.completed },
          ].map(s => (
            <div key={s.label} className="stat-tile card">
              <span className="stat-icon">{s.icon}</span>
              <span className="stat-val">{s.value}</span>
              <span className="stat-lbl">{s.label}</span>
            </div>
          ))}
        </div>

        {/* FREE Service Banner */}
        <div style={{
          background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)',
          border: '1px solid #6ee7b7',
          borderRadius: '14px',
          padding: '16px 20px',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          <h3 style={{ color: '#065f46', margin: '0 0 6px', fontSize: '16px' }}>🎉 Tumhare Liye BILKUL FREE!</h3>
          <p style={{ color: '#047857', margin: 0, fontSize: '14px' }}>
            Platform fee: <strong>Rs. 0</strong> — Hamesha free rahega!
          </p>
        </div>

        {/* CASHBACK BANNER */}
        {!hasCompleted ? (
          // Pehli booking nahi hui — cashback offer dikhao
          <div style={{
            background: 'linear-gradient(135deg, #fdf4ff, #fae8ff)',
            border: '2px solid #d946ef',
            borderRadius: '16px',
            padding: '20px',
            marginBottom: '20px',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Decorative circles */}
            <div style={{
              position: 'absolute', top: '-20px', right: '-20px',
              width: '100px', height: '100px',
              background: 'rgba(217, 70, 239, 0.1)',
              borderRadius: '50%'
            }} />
            <div style={{
              position: 'absolute', bottom: '-30px', left: '-10px',
              width: '80px', height: '80px',
              background: 'rgba(217, 70, 239, 0.08)',
              borderRadius: '50%'
            }} />

            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <span style={{ fontSize: '28px' }}>🎁</span>
                <div>
                  <h3 style={{ color: '#86198f', margin: 0, fontSize: '17px', fontWeight: 800 }}>
                    Pehli Booking Pe CASHBACK!
                  </h3>
                  <p style={{ color: '#a21caf', margin: '2px 0 0', fontSize: '13px' }}>
                    Limited time offer — Sirf new users ke liye
                  </p>
                </div>
              </div>

              <div style={{
                background: 'white',
                borderRadius: '12px',
                padding: '14px 16px',
                marginBottom: '12px',
                border: '1px solid #f0abfc'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <span style={{ color: '#64748b', fontSize: '14px' }}>Tumhari pehli booking</span>
                  <span style={{ color: '#86198f', fontWeight: 700, fontSize: '15px' }}>Complete karo ✅</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <span style={{ color: '#64748b', fontSize: '14px' }}>Cashback milega</span>
                  <span style={{ color: '#16a34a', fontWeight: 800, fontSize: '18px' }}>1% of booking 💰</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#64748b', fontSize: '13px' }}>Example: ₹30,000 ki booking pe</span>
                  <span style={{ color: '#16a34a', fontWeight: 700 }}>₹300 cashback!</span>
                </div>
              </div>

              <div style={{
                background: '#fef9c3',
                borderRadius: '8px',
                padding: '10px 14px',
                fontSize: '13px',
                color: '#854d0e'
              }}>
                💡 <strong>Kaise milega?</strong> Decoration complete hone ke baad complete work ka screenshot bhejiye aur UPI pe cashback paaye!
              </div>

              {stats.total === 0 && (
                <Link to="/decorators" className="btn btn-primary" style={{
                  marginTop: '14px',
                  width: '100%',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #d946ef, #a21caf)',
                  border: 'none',
                  padding: '12px'
                }}>
                  🎊 Pehli Booking Karo — Cashback Pao!
                </Link>
              )}
            </div>
          </div>
        ) : (
          // Pehli booking complete ho gayi — congratulations
          <div style={{
            background: 'linear-gradient(135deg, #fefce8, #fef9c3)',
            border: '2px solid #eab308',
            borderRadius: '16px',
            padding: '20px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '32px', margin: '0 0 8px' }}>🎉</p>
            <h3 style={{ color: '#854d0e', margin: '0 0 6px', fontSize: '17px' }}>
              Cashback Pending Hai!
            </h3>
            <p style={{ color: '#92400e', margin: '0 0 10px', fontSize: '14px' }}>
              Tumhari {completedCount} booking{completedCount > 1 ? 'en' : ''} complete ho gayi!
              Admin jald hi tumse contact karega cashback ke liye. 💰
            </p>
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '10px',
              fontSize: '13px',
              color: '#64748b',
              border: '1px solid #fde68a'
            }}>
              📞 Contact nahi aaya? WhatsApp karo admin ko
            </div>
          </div>
        )}

        {/* Tabs */}
        <div className="tabs" style={{ marginBottom: '24px' }}>
          {['all', 'pending', 'confirmed', 'completed', 'cancelled'].map(tab => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
              {tab !== 'all' && ` (${bookings.filter(b => b.status === tab).length})`}
            </button>
          ))}
        </div>

        {loading ? <div className="spinner" /> : filtered.length === 0 ? (
          <div className="empty-state">
            <h3>Koi booking nahi 😊</h3>
            <p>Apna pehla event book karo aur cashback pao!</p>
            <Link to="/decorators" className="btn btn-primary" style={{ marginTop: '16px' }}>
              🎊 Decorators Dekho
            </Link>
          </div>
        ) : (
          <div className="bookings-list">
            {filtered.map(booking => {
              const status = STATUS_LABELS[booking.status];
              const decoratorName = booking.decorator?.businessName || 'Decorator';
              const cashbackAmount = Math.round(booking.totalAmount * 0.01);
              return (
                <div key={booking._id} className="booking-row card">
                  <div className="booking-info">
                    <div className="booking-main">
                      <h3>{booking.eventType}</h3>
                      <span className={`badge ${status.cls}`}>{status.label}</span>
                    </div>
                    <p>🎨 {decoratorName}</p>
                    <p>📅 {new Date(booking.eventDate).toLocaleDateString('hi-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                    <p>📍 {booking.venue?.address}</p>
                  </div>
                  <div className="booking-right">
                    <div className="booking-amount">
                      <span>Total Budget</span>
                      <strong>₹{booking.totalAmount?.toLocaleString()}</strong>
                    </div>
                    <div className="booking-amount">
                      <span>Payment</span>
                      <span style={{ color: '#10b981', fontWeight: 600, fontSize: '13px' }}>
                        💵 Cash
                      </span>
                    </div>
                    {/* Cashback chip on completed bookings */}
                    {booking.status === 'completed' && (
                      <div style={{
                        background: '#fef9c3',
                        border: '1px solid #fde68a',
                        borderRadius: '8px',
                        padding: '6px 10px',
                        fontSize: '12px',
                        color: '#854d0e',
                        fontWeight: 600,
                        marginTop: '4px'
                      }}>
                        🎁 ₹{cashbackAmount} cashback pending
                      </div>
                    )}
                    <Link to={`/bookings/${booking._id}`} className="btn btn-outline btn-sm" style={{ marginTop: '8px' }}>
                      Details →
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}